// Encabezado de «Accesorios» (paso 05): título con su «?» y subtítulo; los enlaces van aparte.
import { stepBySlug } from '../steps';
import { buildSaleHowItWorks, HowItWorksButton } from './HowItWorksModal';

export const BUILD_SALE_TITLE = 'Agrega accesorios';
export const BUILD_SALE_SUBTITLE = 'Elige lo que acompaña al teléfono.';

/** Nombre del paso al que lleva «Continuar»: Cobro si la venta es derivada, si no Pago. */
export function buildSaleNextStepName(referred: boolean): string {
    return stepBySlug(referred ? 'payment' : 'payment-method')?.short ?? 'Pago';
}

export function BuildSaleHeading({ referred = false }: { referred?: boolean }) {
    return (
        <div className="min-w-0">
            <div className="mb-1 text-[10px] font-semibold uppercase tracking-[0.08em] text-muted-foreground">
                Selección
            </div>
            <div className="mb-1 flex items-center gap-1.5">
                <h1 className="text-[20px] font-semibold leading-[1.2] tracking-[-0.01em]">
                    {BUILD_SALE_TITLE}
                </h1>
                <HowItWorksButton content={buildSaleHowItWorks(buildSaleNextStepName(referred))} />
            </div>
            <p className="text-[13px] leading-[1.5] text-muted-foreground">{BUILD_SALE_SUBTITLE}</p>
        </div>
    );
}
